<template>
    <DashboardAffiliate msg="Welcome to Dashboard ( Home )" v-if="com_user_type_access([2])"/>
    <Dashboard msg="Welcome to Dashboard ( Home )" v-else-if="com_user_type_access([0,1])"/>
    <DashboardFlex msg="Welcome to Dashboard ( Home )" v-else-if="com_user_type_access([3])"/>
    <DashboardSubscriptionsBaseSales msg="Welcome to Dashboard ( Home )" v-else-if="com_user_type_access([4])"/>
</template>

<script>
    // @ is an alias to /src
    import Dashboard from "@/components/Dashboard.vue";
    import DashboardAffiliate from "@/components/DashboardForAffiliate.vue";
    import DashboardFlex from "@/components/Flex/Dashboard.vue";
    import DashboardSubscriptionsBaseSales
        from "@/components/SubscriptionBaseSales/DashboardSubscriptionsBaseSales.vue";

    export default {
        name: "Home",
        components: {
            Dashboard,
            DashboardAffiliate,
            DashboardFlex,
            DashboardSubscriptionsBaseSales
        },
        data() {
            return {}
        },
        created() {

        }
    };
</script>
